import { render, staticRenderFns } from "./IdleDurationReport.vue?vue&type=template&id=18eba1e2&"
import script from "./IdleDurationReport.vue?vue&type=script&lang=js&"
export * from "./IdleDurationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports